import { JSX } from "react";

import {
  Checkboxes,
  CheckboxesProps,
} from "@plansoft-configuration-renderer/components";

import { CustomCheckboxes } from "./CustomCheckboxes";

export function CustomCheckboxesMapper(props: CheckboxesProps): JSX.Element {
  const renderAsSecurityLevel = props.custom?.renderAsSecurityLevel;

  if (renderAsSecurityLevel) {
    return <CustomCheckboxes {...props} />;
  }

  return <Checkboxes {...props} />;
}
